import React from 'react'
import { Table } from 'react-bootstrap'

export default function ProductItemsDataTable({ order }) {
  const roundNoAndSeriesNo = (id) => {
    if (id) {
      return { roundNo: id.slice(3, 5), seriesNo: id.slice(6, 8) }
    }
    return null
  }

  const renderHeader = () => {
    return (
      <thead>
        <tr>
          <th>
            <strong>รหัสแคมเปญ</strong>
          </th>
          <th>
            <strong>จำนวนเครดิต</strong>
          </th>
          <th>
            <strong>จำนวนเงิน</strong>
          </th>
          <th>
            <strong>จำนวนคูปอง</strong>
          </th>
          <th>
            <strong>ยอดเงินรวม</strong>
          </th>
        </tr>
      </thead>
    )
  }

  const productList = (order, product) => {
    return (
      <tr key={product.id}>
        <td>{order.campaignId || '-'}</td>
        <td>{product?.amount || '-'}</td>
        <td>{product?.price || '-'}</td>
        <td>{product?.totalItem || '-'}</td>
        <td>{product?.totalPrice || '-'}</td>
      </tr>
    )
  }

  const renderBody = () => {
    if (order && order.products) {
      const itemElems = order.products.map((item) => productList(order, item))

      return <tbody>{itemElems}</tbody>
    }
  }

  const renderTable = () => {
    return (
      <Table responsive>
        {renderHeader()}
        {renderBody()}
      </Table>
    )
  }

  return renderTable()
}
